import { Title, Button, Text, Badge } from "@mantine/core";
import { IconArrowLeft, IconChartBar, IconUsers, IconMessage2, IconSettings } from "@tabler/icons";
import image from "../public/section5_cut.webp";
import { MediaStage } from "./MediaStage";
import classes from "../styles/EndSection.module.css";

// מטרת הקומפוננטה להציג איך הממשק ניהול נראה, לאומת הסקשן הקודם שמציג את ממשק הלקוח
export function EndSection() {
    const features = [
        { text: "דוחות ביצועים בזמן אמת", icon: <IconChartBar size={24} /> },
        { text: "ניהול עובדים ומשאבים", icon: <IconUsers size={24} /> },
        { text: "מרכז הודעות חכם", icon: <IconMessage2 size={24} /> },
        { text: "שליטה מלאה בהגדרות", icon: <IconSettings size={24} /> },
    ];

    return (
        <div className={classes.wrapper}>
            <div className={classes.image}>
                <MediaStage
                    image={image}
                    variant="phone"
                    tone="deep"
                    callouts={["דוחות בזמן אמת", "ניהול עובדים"]}
                    alt="דוח ביצועים בטלפון: הכנסות באשראי ובמזומן החודש, לקוחות חדשים ופילוח סוגי השירותים"
                />
            </div>

            <div className={classes.body}>
                <Badge
                    size="lg"
                    variant="light"
                    color="violet"
                    className={classes.badge}
                >
                    ניהול מתקדם
                </Badge>

                <Title order={2} className={classes.title}>
                    הקוקפיט של העסק שלך
                </Title>
                <Text className={classes.subtitle}>
                    קבלו החלטות עסקיות על בסיס נתונים, לא ניחושים.
                    כל המידע שאתם צריכים כדי להצמיח את העסק, במקום אחד, נגיש ופשוט להבנה.
                </Text>

                <div className={classes.featureList}>
                    {features.map((feature, index) => (
                        <div key={index} className={classes.featureCard}>
                            <div className={classes.featureIcon}>{feature.icon}</div>
                            <Text className={classes.cardTitle}>{feature.text}</Text>
                        </div>
                    ))}
                </div>

                <Button
                    className={classes.ctaButton}
                    rightSection={<IconArrowLeft size={18} />}
                    component="a"
                    href={"https://app.quicktor.co.il"}
                >
                    נסו את המערכת בחינם &gt;&gt;
                </Button>
            </div>
        </div>
    );
}
